import React from "react";
import Logo from "../assets/slt-mobitel-logo.png";

const Header = ({ apiUrl, checkingAuth, user }) => {
  return (
    <header className="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between px-4 py-2 bg-gradient-to-r from-black/80 via-[#1a0033e6] to-[#2d0066d9] backdrop-blur border-b border-purple-700/40 shadow-lg">
      <img
        src={Logo}
        alt="SLT-MOBITEL"
        className="w-32 sm:w-40 h-auto cursor-pointer drop-shadow-lg transition-transform duration-300 hover:scale-105"
        onClick={() => (window.location.href = "/")}
      />
      <div className="flex flex-col items-start sm:flex-row sm:items-center sm:justify-end gap-1 sm:gap-3 text-xs sm:text-sm mt-1 sm:mt-0">
        {checkingAuth ? (
          <div className="flex items-center gap-2 text-slate-200">
            <div className="w-3 h-3 sm:w-4 sm:h-4 border-2 border-white/30 border-t-white rounded-full animate-spin" />
            <span>Checking login…</span>
          </div>
        ) : user ? (
          <>
            <span className="text-slate-100 max-w-[220px] sm:max-w-none truncate sm:whitespace-normal">
              Hi, {user.name} ({user.email})
            </span>
            <button
              className="px-3 py-1.5 sm:px-4 sm:py-2 rounded-md border border-primaryPurple bg-gradient-to-r from-primaryPurple to-secondaryPurple text-white font-semibold text-xs sm:text-sm shadow hover:-translate-y-px transition"
              onClick={() => (window.location.href = `${apiUrl}/logout`)}
            >
              Logout
            </button>
          </>
        ) : (
          <button
            className="self-end px-3 py-1.5 sm:px-4 sm:py-2 rounded-md border border-primaryPurple bg-gradient-to-r from-primaryPurple to-secondaryPurple text-white font-semibold text-xs sm:text-sm shadow hover:-translate-y-px transition"
            onClick={() => (window.location.href = `${apiUrl}/login`)}
          >
            Login with Microsoft
          </button>
        )}
      </div>
    </header>
  );
};

export default Header;

